import type { AbstractServiceMarker } from '../../core/types';
import { unimplementedAbstractService } from '../../core/utils';

export type FetchInput = RequestInit & { url: string };

export const fetchJSON: (<Response>(input: FetchInput) => Promise<Response>) &
	AbstractServiceMarker =
	// XXX: This is a generic function - careful with types!
	// TypeScript has limitations when transforming generic functions.
	// Here, the function signature will pass through our helper unimplementedAbstractService()
	// untouched, which TypeScript can handle.
	unimplementedAbstractService<<Response>(input: FetchInput) => Promise<Response>>('fetchJSON');
